import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { BusinessModel, OrderDelivery, OrderState, PaymentType, Shop } from '@us/web/shared/data-access';
import { Cart, CartFillable, CartItem, CartMember } from './cart.reducer';

export const CartEffectInitAction = createAction('[Cart] Effect Init');

export const CartActions = createActionGroup({
    source: 'Cart',
    events: {
        'Create Cart': emptyProps(),
        'Create Cart Success': props<{ cart: Cart }>(),
        'Create Cart Failed': props<{ error: string }>(),
        'Add To Cart': props<{ item: CartItem; redirectUrl?: string }>(),
        'Add To Cart Success': props<{ cart: Cart }>(),
        'Add To Cart Failed': props<{ error: string }>(),
        'Remove From Cart': props<{ item: CartItem | { uuid: string } }>(),
        'Remove From Cart Success': props<{ cart: Cart }>(),
        'Remove From Cart Failed': props<{ error: string }>(),
        'Clear Cart': props<{ item?: CartItem; shop?: Shop }>(),
        'Clear Cart Success': props<{ cart: Cart }>(),
        'Clear Cart Failed': props<{ error: string }>(),
        'Update Cart': props<CartFillable>(),
        'Update Cart Success': props<{ cart: Cart }>(),
        'Update Cart Failed': props<{ error: string | null }>(),
        'Update Item Quantity': props<{ item: CartItem; quantity: number }>(),
        'Update Item Quantity Success': props<{ cart: Cart }>(),
        'Update Item Quantity Failed': props<{ error: string | null }>(),
        'Change Delivery Service': props<OrderDelivery>(),
        'Submit Cart': props<{
            businessModel?: BusinessModel;
            paymentType?: PaymentType | null;
        }>(),
        'Submit Cart Success': props<{
            cart: Cart;
            businessModel?: BusinessModel;
        }>(),
        'Submit Cart Failed': props<{ error: string | null }>(),
        'Reset Cart State': emptyProps(),
        'Push Order State': props<{ new_state: OrderState }>(),
        'Push Order State Success': props<{ order: Cart }>(),
        'Push Order State Failed': props<{ error: string | null }>(),
        'Select Table': props<{ tableId: number; shopId?: string }>(),
        'Select Table Success': props<{ cart: Cart }>(),
        'Select Table Failed': props<{ error: string }>(),
        'Update Cart With Promotion': props<CartFillable>(),
        'Join Shared Order': props<{
            cartId: string;
            user: CartMember;
            onSuccess?: () => void;
            onError?: (error: any) => void;
        }>(),
        'Join Shared Order Success': props<{ cart: Cart }>(),
        'Join Shared Order Failed': props<{ error: string | null }>(),
        'Remove Cart Member': props<{ userId: string }>(),
        'Remove Cart Member Success': props<{ cart: Cart }>(),
        'Remove Cart Member Failed': props<{ error: string | null }>(),
        'Get Cart Detail': emptyProps(),
        'Get Cart Detail Success': props<{ cart: Cart }>(),
        'Get Cart Detail Failed': props<{ error: string | null }>()
    }
});
